import { DropDown } from "../Common/dropDown";
import { InputField } from "../Common/inputField";
import TrashIcon from "../../assets/trash-outline.svg";
import { DatePickerInput } from "../Common/datePicker";
import { CurrencyInputField } from "../Common/currencyInput";
import { OperatingTypeMapping } from "../../interfaces/mortgageDetailsInterface";

interface SelfEmploymentBoxProps {
  onRemove: () => void;
  businessName: string;
  dateEstablished: Date | null;
  approximateStartDate: Date | null;
  annualBasePay: string;
  jobTitle: string;
  annualIncome: string;
  operatingType: string;

  businessNameError?: string;
  dateEstablishedError?: string;
  approximateStartDateError?: string;
  annualBasePayError?: string;
  operatingTypeError?: string;
  jobTitleError?: string;
  annualIncomeError?: string;

  setBusinessName: (value: string) => void;
  setDateEstablished: (date: Date | null) => void;
  setApproximateStartDate: (date: Date | null) => void;
  setAnnualBasePay: (value: string) => void;
  setJobTitle: (value: string) => void;
  setAnnualIncome: (value: string) => void;
  setOperatingType: (value: string) => void;
}

const SelfEmploymentBox = ({
  onRemove,
  businessName,
  businessNameError,
  setBusinessName,
  dateEstablished,
  dateEstablishedError,
  setDateEstablished,
  approximateStartDate,
  approximateStartDateError,
  setApproximateStartDate,
  annualBasePay,
  annualBasePayError,
  setAnnualBasePay,
  jobTitle,
  jobTitleError,
  setJobTitle,
  annualIncome,
  annualIncomeError,
  setAnnualIncome,
  operatingType,
  operatingTypeError,
  setOperatingType,
}: SelfEmploymentBoxProps) => {
  const operatingTypeOptions = Object.keys(OperatingTypeMapping);

  return (
    <div className="rounded-[8px] border-[#E5E7EB] border-2">
      <div className="font-medium flex items-center justify-between w-full bg-[#E5E7EB]/50 rounded-t-[8px] border-b-[#E5E7EB] border-b-2 px-3 py-4">
        <div>Self-Employment</div>
        <button
          type="button"
          className="flex items-center gap-1 text-[#EF4444] text-xs font-medium"
          onClick={onRemove}
        >
          Delete <img src={TrashIcon} alt="Delete icon" />
        </button>
      </div>
      <div className="p-4 space-y-6">
        <div className="space-y-2">
          <div className="text-z-dark-moss-green font-medium">
            Employment Details
          </div>
          <div className="grid lg:grid-cols-2 gap-4">
            <div className="w-full space-y-1">
              <InputField
                id="businessName"
                label="Business Name*"
                value={businessName}
                onChange={(e) => setBusinessName(e.target.value)}
              />
              {businessNameError && (
                <p className="text-red-600 text-sm">{businessNameError}</p>
              )}
            </div>
            <div className="w-full space-y-1">
              <DatePickerInput
                label="Date Established*"
                disableFuture={true}
                selectedDate={dateEstablished}
                onDateChange={setDateEstablished}
              />
              {dateEstablishedError && (
                <p className="text-red-600 text-sm">{dateEstablishedError}</p>
              )}
            </div>
            <div className="w-full space-y-1">
              <DatePickerInput
                label="Approximate Start Date*"
                disableFuture={true}
                selectedDate={approximateStartDate}
                onDateChange={setApproximateStartDate}
              />
              {approximateStartDateError && (
                <p className="text-red-600 text-sm">
                  {approximateStartDateError}
                </p>
              )}
            </div>
            <div className="w-full space-y-1">
              <CurrencyInputField
                id="annualBasePay"
                label="Annual Base Pay ($)*"
                value={annualBasePay}
                onChange={setAnnualBasePay}
              />
              {annualBasePayError && (
                <p className="text-red-600 text-sm">{annualBasePayError}</p>
              )}
            </div>
            <div className="w-full space-y-1">
              <DropDown
                label="Operating Type*"
                options={operatingTypeOptions}
                selectedOption={
                  Object.keys(OperatingTypeMapping).find(
                    (key) => OperatingTypeMapping[key] === operatingType
                  ) || ""
                }
                onSelect={(value) =>
                  setOperatingType(OperatingTypeMapping[value])
                }
              />
              {operatingTypeError && (
                <p className="text-red-600 text-sm">{operatingTypeError}</p>
              )}
            </div>
          </div>
        </div>
        <div className="space-y-2">
          <div className="text-z-prussian-blue font-medium">
            Employment Details
          </div>
          <div className="grid lg:grid-cols-2 gap-4">
            <div className="w-full space-y-1">
              <InputField
                id="jobTitle"
                label="Job Title*"
                value={jobTitle}
                onChange={(e) => setJobTitle(e.target.value)}
              />
              {jobTitleError && (
                <p className="text-red-600 text-sm">{jobTitleError}</p>
              )}
            </div>
            <div className="w-full space-y-1">
              <CurrencyInputField
                id="annualIncome"
                label="Annual Income ($)*"
                value={annualIncome}
                onChange={setAnnualIncome}
              />
              {annualIncomeError && (
                <p className="text-red-600 text-sm">{annualIncomeError}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { SelfEmploymentBox };
